import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as api from "@/api/overseasChinese/overseasChinese";
export default {
  data: function data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        avgScore: 0,
        evaluaNumber: 0,
        interaction: 0,
        learnEffect: 0,
        peopleNumber: 0,
        personalAbility: 0
      },
      loading: false,
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10
      },
      total: 0,
      tableData: []
    };
  },
  created: function created() {
    this.getDetail();
    this.initPage();
  },
  methods: {
    initPage: function initPage() {
      var _JSON$parse = JSON.parse(this.$route.query.info),
          day = _JSON$parse.day,
          pkteachclassid = _JSON$parse.pkteachclassid,
          termid = _JSON$parse.termid,
          timeType = _JSON$parse.timeType,
          week = _JSON$parse.week;

      this.paramSearch = _objectSpread(_objectSpread({}, this.paramSearch), {}, {
        day: day,
        pkteachclassid: pkteachclassid,
        semesterId: termid,
        timeType: timeType,
        week: week
      });
      this.getEvaluationScorePage();
    },
    getDetail: function getDetail() {
      var _this = this;

      var _JSON$parse2 = JSON.parse(this.$route.query.info),
          day = _JSON$parse2.day,
          pkteachclassid = _JSON$parse2.pkteachclassid,
          semesterId = _JSON$parse2.semesterId,
          timeType = _JSON$parse2.timeType,
          week = _JSON$parse2.week;

      api.selectEvaluaDetails({
        day: day,
        pkteachclassid: pkteachclassid,
        semesterId: semesterId,
        timeType: timeType,
        week: week
      }).then(function (res) {
        if (res.data.code == 0) {
          _this.formLabelAlign = res.data.data;
        }
      });
    },
    getEvaluationScorePage: function getEvaluationScorePage() {
      var _this2 = this;

      this.loading = true;
      api.selectEvaluaScorePage(this.paramSearch).then(function (res) {
        _this2.loading = false;

        if (res.data.code == 0) {
          _this2.tableData = res.data.data.records || [];
          _this2.total = res.data.data.total;
        }
      }).catch(function () {
        _this2.loading = false;
      });
    },
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getEvaluationScorePage();
    },
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getEvaluationScorePage();
    },
    formatName: function formatName(row) {
      switch (row.anonymousFlag) {
        case "1":
          return "匿名";

        case "0":
          return row.userName;

        default:
          return "";
      }
    }
  }
};